import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetMaskinlagCommand extends BasicCommand<SetMaskinlagCommand> {
    get primaryKey(): IPrimaryKey<SetMaskinlagCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }

    arbetsorderId: number;
    maskinlagId?: number;
    startdatum?: Date;
    isSuggestedDate?: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetMaskinlagCommand";

    constructor(init: (instance: SetMaskinlagCommand) => void) {
        super(SetMaskinlagCommand.$type, SetMaskinlagCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
